// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__8Dmvp","loading":"skeleton_loading__P4NXd"};